import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IUniqueVoucherGeneratedHistory } from '@/shared/model/unique-voucher-generated-history.model';

const baseApiUrl = 'api/unique-voucher-generated-histories';
const baseSearchApiUrl = 'api/_search/unique-voucher-generated-histories?query=';

export default class UniqueVoucherGeneratedHistoryService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IUniqueVoucherGeneratedHistory> {
    return new Promise<IUniqueVoucherGeneratedHistory>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IUniqueVoucherGeneratedHistory): Promise<IUniqueVoucherGeneratedHistory> {
    return new Promise<IUniqueVoucherGeneratedHistory>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IUniqueVoucherGeneratedHistory): Promise<IUniqueVoucherGeneratedHistory> {
    return new Promise<IUniqueVoucherGeneratedHistory>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
